import * as React from "react";
import { IDatasource } from "../IDatasource";

export interface IDatasourcesContextProviderProps {
  children: React.ReactNode;
  datasources: IDatasource[];
}
export const DatasourcesContext = React.createContext<IDatasource[]>([]);

export const useDatasourcesContext = () => React.useContext(DatasourcesContext);

export const DatasourcesContextProvider = (props: IDatasourcesContextProviderProps) => (
  <DatasourcesContext.Provider value={props.datasources}>{props.children}</DatasourcesContext.Provider>
);
